import React, { FC, useState } from 'react';
import { Alert, Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { MaterialMacro } from 'models/material-macro';
import { useTranslation } from 'react-i18next';

type MaterialMacrosActionsProps = {
    onNewMaterialMacroClick: () => void;
    materialMacros: MaterialMacro[];
    materialMacro: MaterialMacro;
    onSelectedMaterialMacro: (selectedMaterialMacro: string) => void;
};
const MaterialMacrosActions: FC<MaterialMacrosActionsProps> = ({
    onNewMaterialMacroClick,
    materialMacros,
    materialMacro,
    onSelectedMaterialMacro,
}: MaterialMacrosActionsProps) => {
    const { t: translate } = useTranslation(['common', 'lab-settings']);
    const [selectedMaterialMacro, setSelectedMaterialMacro] = useState('');

    const handleMaterialMacroChange = (event: SelectChangeEvent<string>) => {
        setSelectedMaterialMacro(event.target.value);
        onSelectedMaterialMacro(event.target.value);
    };

    return (
        <Box mb={3} display="flex" alignItems="center">
            <Grid container spacing={1}>
                <Grid item sm={6} xs={12} sx={{ visibility: !materialMacros.length ? 'hidden' : 'visible' }}>
                    <FormControl style={{ minWidth: 250 }}>
                        <InputLabel>{translate('lab-settings:MATERIAL_MACROS')}</InputLabel>
                        <Select
                            value={materialMacro.name || selectedMaterialMacro}
                            label={translate('lab-settings:MATERIAL_MACROS')}
                            onChange={handleMaterialMacroChange}
                        >
                            {materialMacros.map((macro) => (
                                <MenuItem key={macro._id} value={macro.name}>
                                    {macro.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                <Grid item sm={6} xs={12} sx={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end' }}>
                    <Button variant="contained" onClick={onNewMaterialMacroClick} startIcon={<AddIcon />}>
                        {translate('lab-settings:NEW_MATERIAL_MACRO')}
                    </Button>
                </Grid>
                {!materialMacros.length && (
                    <Grid item xs={12}>
                        <Box mt={2}>
                            <Alert severity="info">{translate('lab-settings:NO_MATERIAL_MACROS')}</Alert>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default MaterialMacrosActions;
